import { alpha } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  mainContainer: {
    width: '100%',
    maxWidth: '1300px',
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  inputContainer: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    width: '70%',
  },
  inputNestedContainer: {
    width: '100%',
  },
  addButtonContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  removeButtonContainer: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  // `&&` outranks v4's `.MuiButtonBase-root { position: relative }` (shared
  // class name, loaded after the v6 styles), which would leave the button in
  // the flow on the left.
  removePaperButton: {
    '&&': {
      position: 'absolute',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
  },
  allowedReposTypePicker: {
    marginRight: theme.spacing(2),
    minWidth: '100px',
  },
  // A half-opaque scrim over the form while it loads. Derived from the
  // theme's own background so light and dark stay in step without a hex here.
  loadingProgress: {
    backgroundColor: alpha(theme.palette.background.paper, 0.5),
    zIndex: 1,
  },
}));
